import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import { getDefaultBaseSettingsConfigFormly } from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  dataTableFieldParseIntoSettingsFormModel,
  dataTableFieldUpdateFromSettingsFormModel,
  defaultDataTableConfigFormModel,
  generateDataTableMainAndDatasetConfigurationFields,
  generateDataTableSearchConfigurationFields,
} from '../data-table-field-type.configurator';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomDataTableFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = defaultDataTableConfigFormModel;
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      ...generateDataTableMainAndDatasetConfigurationFields(),
      ...generateDataTableSearchConfigurationFields(),
    ];
    this.availableValidations.push('tableValidation');
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return dataTableFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return dataTableFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
